export default {
  getFormFields1: (state) => state.formFields1,
  getFormFields1Order: (state) => state.formFields1Order,
  getFormFields2: (state) => state.formFields2,
  getFormFields2Order: (state) => state.formFields2Order,
  getLastAction: (state) => state.lastAction,
  getPreventCopy: (state) => state.preventCopy,
  getSelectedFieldIndex: (state) => state.selectedFieldIndex,
  getFieldByFormAndId:
    (state) =>
    ({ form, id }) => {
      const formFields = state[`formFields${form}`];
      return formFields?.[id] || null;
    },
};
